import { ADD_QUERIES, RESET_QUERIES, SET_CASE_ID, SET_QUERY_DOCS } from "./actions";

const initialState = {
  queries: [],
  queryDocs:[],
  caseId: "",
};

const queryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUERIES:
      let data = state.queries;
      data = action.data;
      return {
        ...state,
        queries: { ...data },
      };
    case SET_CASE_ID:
      // let data1 = state.caseId;
      let data1 = action.data;
      console.log("in case id", data1, action.data);
      return {
        ...state,
        caseId: data1,
      };
      case SET_QUERY_DOCS:
        // let data1 = state.caseId;
        let data2 = action.data;
        console.log("in case id", data2, action.data);
        return {
          ...state,
          queryDocs: data2,
        };
  
    case RESET_QUERIES:
      return initialState;
    default:
      return state;
  }
};
export default queryReducer;
